import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import homeLogo from '../../Assets/Brijesh-main.png';
import Particle from '../Particle';
import Contact from './Contact';
import About from '../About/About';
import Type from './Type';
import Projects from '../Projects/Projects';
import WorkExp from '../Resume/Workexp';
function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{' '}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I am
                <strong className="main-name"> BRIJESH BURFAL</strong>
              </h1>

              <div style={{ padding: 50, textAlign: 'left' }}>
                <Type />
              </div>
            </Col>

            <Col
              md={4}
              style={{
                paddingBottom: 1,
              }}
            >
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{
                  background: 'rgb(34,20,58 ,0.7)',
                  borderRadius: '50%',
                }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <About />
      <WorkExp />
      <Projects />
      <Contact />
    </section>
  );
}

export default Home;
